import { catchAll } from '@sorare/routing';

import {
  FOOTBALL_PLAY,
  FOOTBALL_PLAY_PRO,
  FOOTBALL_PLAY_REWARDS,
  FOOTBALL_PLAY_RIVALS,
} from '@sorare/core/src/constants/__generated__/routes';
import {
  AnimatedOutlet,
  OutletTransition,
} from '@sorare/core/src/routing/AnimatedOutlet';
import { RequireAuth } from '@sorare/core/src/routing/RequireAuth';

const transitions: OutletTransition[] = [
  {
    from: FOOTBALL_PLAY,
    to: catchAll(FOOTBALL_PLAY_PRO),
    direction: 'rightToLeft',
    reversable: true,
  },
  {
    from: FOOTBALL_PLAY,
    to: catchAll(FOOTBALL_PLAY_RIVALS),
    direction: 'rightToLeft',
    reversable: true,
  },
  {
    from: FOOTBALL_PLAY,
    to: catchAll(FOOTBALL_PLAY_REWARDS),
    direction: 'rightToLeft',
    reversable: true,
  },
];

const PlayLayout = () => {
  return (
    <RequireAuth>
      <AnimatedOutlet transitions={transitions} />
    </RequireAuth>
  );
};
export default PlayLayout;
